import React from 'react'

class InitContainer extends React.Component {
  async componentDidMount() {
    const { initialize } = this.props
    initialize()
  }

  render() {
    const {
      children,
    } = this.props

    return (
      <div>
        {children}
      </div>
    )
  }
}


export default InitContainer



// WEBPACK FOOTER //
// ./src/modules/core/components/initContainer.jsx